import Icon from './Icon';

const ChevronRight = ({ className }) => (
  <Icon name="chevron-right" className={className} viewBox="0 0 27 64">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-390.000000, -145.000000)" stroke="#DDDDDD">
        <polyline id="Path-2" points="391 145 416.072754 175.677102 391 209" />
      </g>
    </g>
  </Icon>
);

export default ChevronRight;
